import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { EventCollisionMatch } from 'app/event/models/event-collision-match';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'pioneer-event-collision-modal',
  templateUrl: './event-collision-modal.component.html',
  styleUrls: ['./event-collision-modal.component.css']
})
export class EventCollisionModalComponent implements OnInit {

  @Input()
  public cancel = 'MESSAGES.COLLISION.CREATE';

  @Input()
  public confirm = 'MESSAGES.COLLISION.CONFIRM';

  @Input()
  public title = 'MESSAGES.COLLISION.TITLE';

  @Input()
  public content = 'MESSAGES.COLLISION.INSTRUCTION_TEXT';

  @Input()
  public contentFinal = 'MESSAGES.COLLISION.INSTRUCTION_FINAL_TEXT';

  @Input()
  public heading = 'MESSAGES.COLLISION.HEADING';

  @Input()
  public headingDetails = 'MESSAGES.COLLISION.HEADING_DETAILS';

  @Input()
  public eventMatch: EventCollisionMatch;

  @Input()
  public match: any | null = {};

  @Input()
  public config = {
    backdrop: 'static'
  };

  @Output()
  public closed = new EventEmitter();

  @ViewChild(ModalDirective)
  public confirmationModal: ModalDirective;

  get isShown(): boolean { return this.confirmationModal.isShown; }

  constructor() { }

  ngOnInit() {
  }

  public open(eventMatch: EventCollisionMatch, match: any): void {
    this.eventMatch = eventMatch;
    this.match = match;
    this.confirmationModal.show();
  }

  public close(value: boolean): void {
    this.closed.emit(value);
    this.confirmationModal.hide();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/event-collision-modal/event-collision-modal.component.ts